import { CsvJerseyPlayer } from "../Players.types";

export type CsvJerseyRow = {
  playerId?: string;
  playerID?: string;
  jerseyNumber?: string | number;
  displayName?: string;
  playerName?: string;
};

const readNumericPlayerId = (row: CsvJerseyRow): number => {
  const fromPlayerID = Number(row.playerID);
  if (Number.isFinite(fromPlayerID) && fromPlayerID > 0) {
    return fromPlayerID;
  }
  return Number(row.playerId);
};

export const collectCsvJerseyPlayers = (
  rows: CsvJerseyRow[],
): CsvJerseyPlayer[] => {
  const playersById = new Map<number, CsvJerseyPlayer>();

  for (const row of rows) {
    const playerID = readNumericPlayerId(row);
    const jerseyRaw =
      row.jerseyNumber === null || row.jerseyNumber === undefined
        ? ""
        : String(row.jerseyNumber).trim();
    const jerseyNumber = Number(jerseyRaw);

    if (!Number.isFinite(playerID) || playerID <= 0) {
      continue;
    }
    if (
      !jerseyRaw ||
      !Number.isFinite(jerseyNumber) ||
      jerseyNumber < 0 ||
      jerseyNumber > 99
    ) {
      continue;
    }

    playersById.set(playerID, {
      playerID,
      jerseyNumber,
      displayName:
        row.displayName?.trim() || row.playerName?.trim() || undefined,
    });
  }

  return Array.from(playersById.values());
};
